module.exports = __webpack_public_path__ + "static/media/filtro-soft.32001809.jpg";